export const PanelMode = {
  RECENT: 'recent',
  SEARCH: 'search',
};